exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".popper{border:none;max-width:25rem;border-radius:7px;text-align:initial;box-shadow:var(--default-box-shadow);background-color:var(--default-card-bg)}.popper[x-placement^=bottom] .popper__arrow,.popper[x-placement^=top] .popper__arrow{border-color:var(--default-card-bg)}.popper .popover-header{display:none}.popper .popover-body{z-index:2;padding:0;border:none}", ""]);

// exports
